import { autoserialize, inheritSerialization } from 'cerialize';
import { AbstractModel } from './abstract-model';

@inheritSerialization(AbstractModel)
export class CollectionRequest extends AbstractModel {
  @autoserialize
  paymentAccountId: number;

  @autoserialize
  chargeIds: Array<number>;
}
